var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DateViewPicker',{attrs:{"date":_vm.date},on:{"dateChanged":_vm.dateChanged}}),_vm._l((_vm.slots),function(slot){return _c('div',{key:slot},[_c('div',{staticClass:"px-3 py-2 m-2 inline-block border"},[_vm._v("\n      "+_vm._s(_vm._f("moment")(slot.time,"HH:mm"))+"\n    ")])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }